import { useMemo } from 'react';

import { useStoreAvailabilityFns } from 'features/store/hooks/use-store-availability-fns';

import { IRestaurant } from '@rbi-ctg/store';
import { t } from 'state/intl/translations';

interface UseErrorMessageOptions {
  restaurant: IRestaurant;
}

export const useErrorMessage = ({ restaurant }: UseErrorMessageOptions) => {
  const { isMobileOrderingAvailable, isPOSAvailable } = useStoreAvailabilityFns();

  return useMemo(() => {
    let errorMessage: string | undefined;
    if (!isMobileOrderingAvailable(restaurant) || !isPOSAvailable(restaurant)) {
      errorMessage = t('mobileOrderingUnavailable');
    }

    return errorMessage;
  }, [isMobileOrderingAvailable, isPOSAvailable, restaurant]);
};
